import { gql } from '@apollo/client';

const getMetadata = () => {
  const query = gql`
    query MetaDataQuery($parentId: String!) {
      metadata(parentId: $parentId) {
        attributes {
          attributeName
          attributeValues {
            value
            swatchGuid
            __typename
          }
          isSwatch
          __typename
        }
        childItemsLookup {
          attributeCombination
          itemId
          canonicalUrl
          isItemBackOrdered
          __typename
        }
        superDuperSku {
          attributes {
            attributeName
            attributeValues {
              value
              selected
              superSkuUrl
              __typename
            }
            __typename
          }
          __typename
        }
        sizeAndFitDetail {
          attributeGroups {
            dimensionLabel
            productType
            attributes {
              dimensions
              attributeName
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
    }
  `;
  return query;
};
export default getMetadata;
